<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-form-item>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="开始日期"
              v-model="form.beginTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
          <el-col
            class="line"
            :span="1"
          >-</el-col>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="结束日期"
              v-model="form.endTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button
        size="small"
        type="primary"
        @click="getData"
      >查询</el-button>
      <el-button
        size="small"
        @click="onAdd"
      >新增</el-button>
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <!-- :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="userName"
          label="上传人"
          minWidth="120"
          align="center"
        />
        <el-table-column
          prop="fileName"
          label="文件名"
          minWidth="130"
          align="center"
        />
        <el-table-column
          property="createTime"
          label="上传时间"
          minWidth="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              @click="onDel(scope.row.id)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getData"
        @current-change="currentChange"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
    <div slot="plugins">
      <FileForm :visible.sync="formVisible" @onSuccess="currentChange(1)" />
    </div>
  </ManageBox>
</template>

<script>
import day from "dayjs";
import ManageBox from "@/components/ManageBox/index.vue";
import { mapState } from 'vuex';
import FileForm from './components/FileForm.vue';
import { MessageBox } from 'element-ui';

export default {
  components: {
    ManageBox,
    FileForm
  },
  data() {
    return {
      formVisible:false,
      loading: false,
      currentPage: 1,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0,
      form: {
        beginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        ),
        endTime: day(new Date()).format("YYYY-MM-DD 23:59:59:0"),
        dayBeginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        )
      },
    };
  },
  computed:{
      ...mapState(['USER']),
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
  },

  methods: {
    // 删除
    onDel(id){
      this.$msgBox.confirm('是否确认删除该文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try{
          const { code, msg } = await this.$API.deleteUpgradeFiles({ id });
          if(code !== 0) throw { msg };
          this.currentChange(1);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }catch({ msg }){
          this.$msg({
            type:'error',
            message:msg,
          });
        }

      }).catch(() => {});
    },
    // 新增
    onAdd(){
      this.formVisible = true;
    },
    currentChange (val) {
      this.currentPage = val;
      this.getData();
    },
    //获取电池历史数据
    async getData() {
      let params = {
        startTime: day(this.form.beginTime || this.form.dayBeginTime).format(
          "YYYY-MM-DD HH:mm:ss:0"
        ),
        endTime: day(this.form.endTime || new Date()).format(
          "YYYY-MM-DD HH:mm:ss:999"
        ),
        pageSize:this.pageSize,
        pageNumber:this.currentPage
      };
      if (this.form.beginTime > this.form.endTime) {
        this.$msg({
          showClose: true,
          message: "开始时间不能大于结束时间!",
          type: "error"
        });
        return;
      }
      this.getParams = params;
      try {
        this.loading = true;
        const { data, total, code, msg } = await this.$API.pageUpgradeFiles(params);
        if(code !== 0) throw { msg };
        this.total = total;
        this.tableData = data?.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        })) ?? [];
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      } finally{
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
  &__footer {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 420px;
}
::v-deep .el-col-1 {
  margin-left: 2%;
}
</style>
